import { Layout, SystemMessages } from "components"
export const SystemMessagesPage = () => {
 return (
  <Layout>
   <SystemMessages />
  </Layout>
 )
}
